import $http from "@/plugins/axios"

export default {
    state: {
        listDiseaseSubcategories: [],
    },
    getters: {
        listDiseaseSubcategories: state => state.listDiseaseSubcategories
    },
    actions: {
        async getListDiseaseSubcategories({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.listDiseaseSubcategories = data
        }
    }
}